import { render, staticRenderFns } from "./Userpreferences.vue?vue&type=template&id=194a8e54&"
import script from "./Userpreferences.vue?vue&type=script&lang=js&"
export * from "./Userpreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports